function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.263 9.372a1.502 1.502 0 01-1.506-1.498c0-.827.674-1.498 1.506-1.498s1.506.671 1.506 1.498-.674 1.498-1.506 1.498zm0-5.377a1.502 1.502 0 01-1.506-1.497C8.757 1.67 9.431 1 10.263 1s1.506.671 1.506 1.498c0 .826-.674 1.497-1.506 1.497zm0 10.753a1.502 1.502 0 01-1.506-1.498c0-.826.674-1.497 1.506-1.497s1.506.67 1.506 1.497c0 .827-.674 1.498-1.506 1.498zM5.506 9.372A1.502 1.502 0 014 7.874c0-.827.674-1.498 1.506-1.498s1.505.671 1.505 1.498-.673 1.498-1.505 1.498zm0-5.377A1.502 1.502 0 014 2.498C4 1.67 4.674 1 5.506 1s1.505.671 1.505 1.498c0 .826-.673 1.497-1.505 1.497zm0 10.753A1.502 1.502 0 014 13.25c0-.826.674-1.497 1.506-1.497s1.505.67 1.505 1.497c0 .827-.673 1.498-1.505 1.498z",
  id: "a"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#858D94",
  xlinkHref: "#a",
  transform: "translate(-4 -1)",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default SvgComponent;